import { render, staticRenderFns } from "./AnimatedButton.vue?vue&type=template&id=50320ace&scoped=true&"
import script from "./AnimatedButton.vue?vue&type=script&lang=js&"
export * from "./AnimatedButton.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedButton.vue?vue&type=style&index=0&id=50320ace&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50320ace",
  null
  
)

export default component.exports